// initial state
import * as base from './base.js'
const baseName = '/admin/system/inventory'
const typesName = '/admin/system/consumableType'
const consumablesreceiveName = '/admin/system/receive'
const consumablesclaimName = '/admin/system/inventory/receive'

const consumables = baseName + '/list'
const consumablesClass = typesName + '/list'
const consumablesreceive = consumablesreceiveName + '/consumableList'
const consumablesrstate = baseName + '/state'




const obj = base.setBaseUrl('consumables', baseName)
const obj1 = base.setBaseUrl('consumablesClass', typesName)
const obj2 = base.setBaseUrl('consumablesreceive', consumablesreceiveName)
const obj3 = base.setBaseUrl('consumablesclaim', consumablesclaimName)
const obj4 = base.setBaseUrl('consumablesrstate', baseName)




const a = Object.assign(obj,obj1,obj2,obj3,obj4,{consumables,consumablesClass,consumablesreceive,consumablesrstate})
export default a
